/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Quima_backend
 * OpenAPI spec version: v1
 */
import axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  GetDownloadvideoParams,
  GetGetuseridbyfilenameParams,
  GetGetvideobyidParams,
  GetGetvideobyuseridParams,
  GetStreamvideoParams
} from '../generated.schemas';




  export const getVideo = (axiosInstance: AxiosInstance = axios) => {
/**
 * @summary Downloads a video file from the server.
 */
const getDownloadvideo = (
    params?: GetDownloadvideoParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/downloadvideo`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Streams a video file from the server.
 */
const getStreamvideo = (
    params?: GetStreamvideoParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/streamvideo`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Deletes a video from the server and database.
 */
const deleteDeletevideoVideoId = (
    videoId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(
      `/deletevideo/${videoId}`,options
    );
  }
/**
 * @summary Searches for a video by its ID.
 */
const getGetvideobyid = (
    params?: GetGetvideobyidParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/getvideobyid`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Searches for videos by the user ID.
 */
const getGetvideobyuserid = (
    params?: GetGetvideobyuseridParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/getvideobyuserid`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Searches for all videos.
 */
const getGetallvideos = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/getallvideos`,options
    );
  }
/**
 * @summary Searches for a user ID by the video filename.
 */
const getGetuseridbyfilename = (
    params?: GetGetuseridbyfilenameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/getuseridbyfilename`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Retrieves a specific segment of the HLS stream for ABR (Adaptive Bitrate) streaming.
 */
const getApiVideoGethlsstreamSegmentVideoIdFilePath = (
    videoId: number,
    filePath: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Video/gethlsstream/segment/${videoId}/${filePath}`,options
    );
  }
/**
 * @summary Gets the master HLS stream for a video.
 */
const getGethlsstreamMasterVideoId = (
    videoId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/gethlsstream/master/${videoId}`,options
    );
  }
return {getDownloadvideo,getStreamvideo,deleteDeletevideoVideoId,getGetvideobyid,getGetvideobyuserid,getGetallvideos,getGetuseridbyfilename,getApiVideoGethlsstreamSegmentVideoIdFilePath,getGethlsstreamMasterVideoId}};
export type GetDownloadvideoResult = AxiosResponse<void>
export type GetStreamvideoResult = AxiosResponse<void>
export type DeleteDeletevideoVideoIdResult = AxiosResponse<void>
export type GetGetvideobyidResult = AxiosResponse<void>
export type GetGetvideobyuseridResult = AxiosResponse<void>
export type GetGetallvideosResult = AxiosResponse<void>
export type GetGetuseridbyfilenameResult = AxiosResponse<void>
export type GetApiVideoGethlsstreamSegmentVideoIdFilePathResult = AxiosResponse<void>
export type GetGethlsstreamMasterVideoIdResult = AxiosResponse<void>
